// Modules
import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import { formatCPF } from '@brazilian-utils/brazilian-utils'
import { TextField } from '@dasa-health/components-react'
import * as Yup from 'yup'

// Application
import { FederalTaxIdSchema } from 'validators/schema'
import { convertToNumber } from 'utils'
import { InfoBoxProps } from 'typings/components'

// Components
import { InfoBox } from 'components'
import { StyledForm } from './styles'
import { SignUpFooter } from 'redesign/components/molecules/SignUpFooter'

export interface CPFInitial {
    username: string
}
interface Props {
    initialValues: CPFInitial
    handleSubmit: (values: CPFInitial, bag: FormikHelpers<CPFInitial>) => void
    isSubmitting: boolean
    submitText?: string
    isOnlyCPF?: {
        validateSchema: Yup.BaseSchema
    }
    infoBox?: InfoBoxProps
}

type Event = React.ChangeEvent<HTMLInputElement>

export const CPF: React.FC<Props> = ({ initialValues, isSubmitting, handleSubmit, submitText, isOnlyCPF, infoBox }) => {
    const handleNewChange = (e: Event, handleChange: (e: Event) => void) => {
        const {
            target: { value },
        } = e
        const newValue = convertToNumber(value)
        e.target.value = newValue.length === 11 ? formatCPF(newValue) : newValue

        handleChange(e)
    }
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, bag) => handleSubmit(values, bag)}
            validationSchema={isOnlyCPF ? isOnlyCPF.validateSchema : FederalTaxIdSchema}
        >
            {({ values, touched, errors, dirty, isValid, handleChange }) => (
                <StyledForm>
                    <Form data-testid="cpf-form">
                        <div className="form__cpf">
                            <Field
                                as={TextField}
                                className="form__cpf__field"
                                data-testid="cpf-input"
                                helperText={touched.username && errors.username ? errors.username : ''}
                                inputmode="numeric"
                                label="CPF"
                                maxLength={14}
                                name="username"
                                onChange={(e: Event) => handleNewChange(e, handleChange)}
                                type="tel"
                                value={values.username}
                                variant={touched.username && errors.username ? 'error' : undefined}
                            />
                        </div>
                        {infoBox && (
                            <InfoBox className="box" link={infoBox.link} paragraph={infoBox.paragraph} title={infoBox.title} />
                        )}
                        <SignUpFooter
                            isSubmitButtonDisabled={!initialValues.username && (!isValid || !dirty)}
                            isSubmitButtonLoading={isSubmitting}
                            submitButtonText={submitText || 'Continuar'}
                        />
                    </Form>
                </StyledForm>
            )}
        </Formik>
    )
}
